import React from 'react'
import {Button, Dialog, DialogContent} from '@material-ui/core'

import {useTranslation} from 'react-i18next'
import useStyles from 'pages/ProductRegistrationOrganization/Component/style'

type DialogActiveProductProps = {
  open: boolean
  onClose: () => void
  listRegister?: string[]
  listUnRegister?: string[]
  productName?: string
  onConfirm: () => void
}

const DialogConfirm = (props: DialogActiveProductProps) => {
  const {open, onClose, listRegister, listUnRegister, productName, onConfirm} =
    props
  const classes = useStyles()
  const {t} = useTranslation()

  return (
    <Dialog
      open={open}
      onClose={onClose}
      className={classes.container}
      maxWidth='md'
    >
      <DialogContent className={classes.contentWrap}>
        {listRegister && listRegister.length > 0 && (
          <>
            <div className={classes.headerDialog}>
              {t('IProductRegistrationOrganization')}
            </div>
            <div className={classes.infoCard}>
              <div className={classes.infoItem}>
                <span className={classes.infoLabel}>
                  {t('IProductNameSelect')}:
                </span>
                <span className={classes.infoValue}>{productName}</span>
              </div>

              <div className={classes.infoLabel}>{t('IDesignatedAgency')}:</div>
              {listRegister?.map((item, index) => (
                <div className={classes.infoValue} key={`${item} ${index}`}>
                  * {item}
                </div>
              ))}
            </div>
          </>
        )}
        {listUnRegister && listUnRegister.length > 0 && (
          <>
            <div className={classes.headerDialog}>
              {t('IProductUnregistrationOrganization')}
            </div>
            <div className={classes.dangerCard}>
              <div className={classes.infoItem}>
                <span className={classes.infoLabel}>
                  {t('IProductNameSelect')}:
                </span>
                <span className={classes.dangerValue}>{productName}</span>
              </div>
              <div className={classes.infoLabel}>{t('IDesignatedAgency')}:</div>
              {listUnRegister?.map((item) => (
                <div className={classes.dangerValue}>* {item}</div>
              ))}
            </div>
          </>
        )}

        <div className={classes.listBtn}>
          <Button color='primary' variant='contained' onClick={() => onClose()}>
            {t('ICancel')}
          </Button>
          <Button color='primary' variant='contained' onClick={onConfirm}>
            {t('IConfirm')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default DialogConfirm
